import { CompanyInfo } from '@features/dashboard/specialistDashboard/specialistCards/comanyInfo';
import { CommunicationCard } from '@features/dashboard/specialistDashboard/specialistCards/communication';
import { UserCardWrapper } from '@features/dashboard/specialistDashboard/specialistCards/userCardWrapper';
import { WhatIOffer } from '@features/dashboard/specialistDashboard/specialistCards/WhatIOffer';
import { WorkExperienceCard } from '@features/dashboard/specialistDashboard/specialistCards/workExperienceCard';
import { useAppbarTitle } from '@hooks/useAppbarTitle';
import { Box, CircularProgress } from '@mui/material';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getUserFullDataById } from 'services/users';
import './styles.css';

export const SpecialistPage = () => {
	const { id } = useParams();

	const [user, setUser] = useState<any>(null);
	const [isLoading, setIsLoading] = useState(true);

	useAppbarTitle('requestsOffers');

	useEffect(() => {
		const fetchUser = async () => {
			try {
				setIsLoading(true);
				const user = await getUserFullDataById(id as string);
				setUser(user);
			} catch (error) {
				console.error('Error fetching user data:', error);
			} finally {
				setIsLoading(false);
			}
		};

		fetchUser();
	}, [id, setUser]);

	if (isLoading) {
		return (
			<Box className="flex justify-center items-center h-64">
				<CircularProgress />
			</Box>
		);
	}

	return (
		<div className=" flex flex-col max-md:justify-center max-md:items-center">
			<UserCardWrapper
				showEdit={false}
				firstName={user?.first_name || ''}
				lastName={user?.last_name || ''}
				user={user}
			/>
			<div className="flex gap-[20px] mt-[20px] max-md:flex-col">
				<div className="flex flex-col gap-[20px] pb-5 w-full">
					{user?.company && <CompanyInfo readonly user={user} />}
					<WhatIOffer readonly user={user} />
					<WorkExperienceCard readonly user={user} />
				</div>
				<div className="flex flex-col gap-[20px] pb-5 w-full">
					<CommunicationCard readonly user={user} />
				</div>
			</div>
		</div>
	);
};
